import React from "react";
import { Link } from "react-router-dom";
import { MarketingLayout } from "../../components/marketing/MarketingLayout";
import { MarketingCTA } from "../../components/marketing/MarketingCTA";
import { SEO } from "../../components/seo/SEO";
import { breadcrumbSchema } from "../../components/seo/schema";
import { getMarketingIcon } from "../../data/marketingIcons";
import { INDUSTRIES } from "../../data/industriesData";

export default function IndustriesIndex() {
  const breadcrumb = [{ name: "Home", path: "/" }, { name: "Industries", path: "/industries" }];
  return (
    <MarketingLayout breadcrumb={breadcrumb}>
      <SEO
        title="Home Service Industries We Serve | ServiceGuru Pro"
        description="ServiceGuru Pro serves HVAC, plumbing, electrical, pool service, landscaping, roofing, and general contracting businesses with software built around each trade's workflow."
        path="/industries"
        jsonLd={[breadcrumbSchema(breadcrumb)]}
      />
      <section className="max-w-4xl mx-auto px-5 lg:px-8 pt-12 pb-14 text-center">
        <h1 className="text-4xl sm:text-5xl font-black tracking-tight leading-[1.05] mb-5" data-testid="industries-index-h1">
          Built for Every Home Service Trade
        </h1>
        <p className="text-[15.5px] text-slate-400 leading-relaxed max-w-2xl mx-auto">
          ServiceGuru Pro adapts to how your trade actually works — the same platform, tuned to your industry's workflow.
        </p>
      </section>

      <section className="max-w-6xl mx-auto px-5 lg:px-8 pb-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {INDUSTRIES.map((ind) => {
            const Icon = getMarketingIcon(ind.icon);
            return (
              <Link
                key={ind.slug}
                to={`/industries/${ind.slug}`}
                data-testid={`industries-index-card-${ind.slug}`}
                className="rounded-2xl border border-white/10 bg-white/[0.02] p-5 hover:border-amber-400/50 hover:bg-white/[0.04] transition-colors group"
              >
                <div className="h-10 w-10 rounded-xl bg-amber-500/15 border border-amber-500/20 flex items-center justify-center mb-3">
                  <Icon className="h-5 w-5 text-amber-400" />
                </div>
                <h3 className="text-white font-semibold text-[14.5px] group-hover:text-amber-400 transition-colors">{ind.title}</h3>
              </Link>
            );
          })}
        </div>
      </section>

      <MarketingCTA heading="Don't see your exact trade?" sub="ServiceGuru Pro flexes to fit most home service and field service businesses. Start your free trial and see for yourself." />
    </MarketingLayout>
  );
}
